import React from 'react';
import {
  ArrayFieldTemplateProps,
} from '@rjsf/utils';
import {
  Box,
  Grid,
  Paper,
  IconButton,
  Button,
} from '@material-ui/core';
import { Add as AddIcon, ArrowUpward, ArrowDownward, Remove } from '@material-ui/icons';

/** The `ArrayFieldTemplate` component is the template used to render all items in an array.
 *
 * @param props - The `ArrayFieldTemplateProps` for this component
 */
export default function CustomArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const {
    canAdd,
    disabled,
    idSchema,
    uiSchema,
    items,
    onAddClick,
    readonly,
    registry,
    required,
    schema,
    title,
  } = props;

  const uiOptions = uiSchema?.['ui:options'] || {};
  const ArrayFieldDescriptionTemplate = registry.templates.ArrayFieldDescriptionTemplate;
  const ArrayFieldTitleTemplate = registry.templates.ArrayFieldTitleTemplate;

  // Generate add button label based on title or schema
  const getAddButtonLabel = () => {
    if (uiOptions.addLabel) {
      return uiOptions.addLabel;
    }
    
    const singularTitle = title?.replace(/s$/, '') || 'Item';
    return `Add ${singularTitle}`;
  };

  return (
    <Paper elevation={2}>
      <Box p={2}>
        <ArrayFieldTitleTemplate
          idSchema={idSchema}
          title={title}
          schema={schema}
          uiSchema={uiSchema}
          required={required}
          registry={registry}
        />
        <ArrayFieldDescriptionTemplate
          idSchema={idSchema}
          description={schema.description}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
        <Grid container={true} spacing={2}>
          {items &&
            items.map((element: any) => (
              <Grid item={true} xs={12} key={element.key}>
                <Box mb={2}>
                  <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>{element.children}</Box>
                    <Box ml={1}>
                      {element.hasMoveUp && (
                        <IconButton
                          size="small"
                          disabled={disabled || readonly}
                          onClick={element.onReorderClick(element.index, element.index - 1)}
                        >
                          <ArrowUpward />
                        </IconButton>
                      )}
                      {element.hasMoveDown && (
                        <IconButton
                          size="small"
                          disabled={disabled || readonly}
                          onClick={element.onReorderClick(element.index, element.index + 1)}
                        >
                          <ArrowDownward />
                        </IconButton>
                      )}
                      {element.hasRemove && (
                        <IconButton
                          size="small"
                          disabled={disabled || readonly}
                          onClick={element.onDropIndexClick(element.index)}
                          color="secondary"
                        >
                          <Remove />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          {canAdd && (
            <Grid item={true} xs={12}>
              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  color="primary"
                  disabled={disabled || readonly}
                  onClick={onAddClick}
                  startIcon={<AddIcon />}
                  variant="outlined"
                >
                  {getAddButtonLabel()}
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </Paper>
  );
}